var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 29,
    rx: 29,
    ry: 29,
    fill: "#4B4B4B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0768 28.6015L21.1981 39.5495C21.1353 39.6122 21.0855 39.6867 21.0515 39.7689C21.0175 39.851 21 39.9392 21 40.0281C21 40.1171 21.0175 40.2053 21.0515 40.2874C21.0855 40.3696 21.1353 40.4441 21.1981 40.5068L24.4805 43.81C24.5406 43.8745 24.6133 43.9259 24.6939 43.9611C24.7746 43.9962 24.8615 44.0143 24.9494 44.0143C25.0372 44.0143 25.1243 43.9962 25.2049 43.9611C25.2855 43.9259 25.3582 43.8745 25.4183 43.81L40.1554 28.9791C40.2195 28.9185 40.2705 28.8454 40.3054 28.7643C40.3404 28.6831 40.3583 28.5956 40.3583 28.5072C40.3583 28.4187 40.3404 28.3312 40.3054 28.2501C40.2705 28.1689 40.2195 28.0958 40.1554 28.0353L25.4183 13.2043C25.3582 13.1398 25.2855 13.0884 25.2049 13.0533C25.1243 13.0181 25.0372 13 24.9494 13C24.8615 13 24.7746 13.0181 24.6939 13.0533C24.6133 13.0884 24.5406 13.1398 24.4805 13.2043L21.1981 16.5076C21.1353 16.5702 21.0855 16.6448 21.0515 16.7269C21.0175 16.8091 21 16.8972 21 16.9862C21 17.0752 21.0175 17.1633 21.0515 17.2455C21.0855 17.3276 21.1353 17.4022 21.1981 17.4648L29.826 26.1342",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightArrow);
export default __webpack_public_path__ + "static/media/icon_right_arrow.5b3ef5a71310639ebb08e115e2a5fb2e.svg";
export { ForwardRef as ReactComponent };